import { render, staticRenderFns } from "./mainApp.vue?vue&type=template&id=d22c4bda&scoped=true"
import script from "./mainApp.vue?vue&type=script&lang=js"
export * from "./mainApp.vue?vue&type=script&lang=js"
import style0 from "./mainApp.vue?vue&type=style&index=0&id=d22c4bda&prod&scoped=true&lang=css"
import style1 from "./mainApp.vue?vue&type=style&index=1&id=d22c4bda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22c4bda",
  null
  
)

export default component.exports